import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - Information Panel';

export default function AOClpInformationPanel() {
  const initiate = () => {
    $('.js-ao-clp-information-panel__link').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');

      if (!clickedElementLink) {
        return;
      }

      sendGoogleEvent(
        EVENT_CATEGORY,
        clickedElementLink,
        $clickedElement.hasClass('ao-clp-information-panel__image-wrapper') ? 'Image Click' : 'CTA click',
      );
    });
  };

  return { initiate };
}
